import client from '../client';

export interface OrderNote {
  Id: number;
  OrderId: number;
  Note: string;
  CreateBy: string;
  CreateDate: string;
}

export interface CreateOrderNoteRequest {
  Note: string;
  CreateBy: string;
}

export const orderNoteService = {
  /**
   * Get all notes for an order
   */
  getOrderNotes: async (orderId: number): Promise<OrderNote[]> => {
    const response: any = await client.get(`/orders/${orderId}/notes`);
    return response.data || [];
  },

  /**
   * Create a new note for an order
   */
  createOrderNote: async (orderId: number, data: CreateOrderNoteRequest): Promise<OrderNote> => {
    const response: any = await client.post(`/orders/${orderId}/notes`, data);
    return response.data;
  },

  /**
   * Delete a note
   */
  deleteOrderNote: async (orderId: number, noteId: number): Promise<void> => {
    await client.delete(`/orders/${orderId}/notes/${noteId}`);
  }
};
